var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifyStationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41671 2.75033V0.916992H8.25004V2.75033H13.75V0.916992H15.5834V2.75033H19.25C19.7563 2.75033 20.1667 3.16074 20.1667 3.66699V10.0837H18.3334V4.58366H15.5834V6.41699H13.75V4.58366H8.25004V6.41699H6.41671V4.58366H3.66671V17.417H9.16671V19.2503H2.75004C2.24378 19.2503 1.83337 18.8399 1.83337 18.3337V3.66699C1.83337 3.16074 2.24378 2.75033 2.75004 2.75033H6.41671Z",
    fill: "#008662"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0833 19.7119C21.0825 19.8322 21.0343 19.9474 20.9493 20.0326C20.8642 20.1178 20.749 20.166 20.6287 20.167H12.3713C12.2507 20.1669 12.1351 20.1189 12.0498 20.0335C11.9646 19.9482 11.9167 19.8325 11.9167 19.7119V19.2503H20.1667V13.8878L16.5 17.1878L11.9167 13.0628V12.3753C11.9167 12.2538 11.965 12.1372 12.0509 12.0512C12.1369 11.9653 12.2534 11.917 12.375 11.917H20.625C20.7466 11.917 20.8631 11.9653 20.9491 12.0512C21.035 12.1372 21.0833 12.2538 21.0833 12.3753V19.7119ZM13.0323 12.8337L16.5 15.9549L19.9678 12.8337H13.0323ZM11 17.417H14.6667V18.3337H11V17.417ZM11 15.1253H13.2917V16.042H11V15.1253Z",
    fill: "#008662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyStationsIcon);
export default __webpack_public_path__ + "static/media/notify-stations-icon.6403504387d392ec52a6a74be07c3f70.svg";
export { ForwardRef as ReactComponent };